import { getRatePlansByProperty } from "../api";
import { createAppSlice } from "./createAppSlice";

export const EDITABLE_FILTER = {
  ALL: "ALL",
  EDITABLE: "EDITABLE",
  NON_EDITABLE: "NON_EDITABLE",
};

const rateplanSlice = createAppSlice({
  name: "rateplan",
  initialState: {
    rateplans: [],
    loading: false,
    error: null,
    selectedRateplan: null,
    editableFilter: EDITABLE_FILTER.ALL,
  },
  reducers: (create) => ({
    setSelectedRateplan: (state, action) => {
      state.selectedRateplan = action.payload;
    },
    setEditableFilter: (state, action) => {
      state.editableFilter = action.payload;
    },
    getRatePlansByPropertyId: create.asyncThunk(
      async (propertyId, { getState }) => {
        const existingRateplans = rateplanSlice
          .getSelectors()
          .selectRateplans(getState()[rateplanSlice.name]);
        if (existingRateplans?.some((item) => item.propertyId === propertyId)) {
          return;
        }

        const response = await getRatePlansByProperty(propertyId);
        return response.data.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          if (action.payload?.length > 0) {
            state.rateplans = action.payload;
            // Auto-select first rate plan if none is selected
            if (!state.selectedRateplan) {
              const firstRateplan = action.payload[0];
              state.selectedRateplan = {
                label:
                  firstRateplan.code && firstRateplan.name
                    ? `${firstRateplan.code}-${firstRateplan.name}`
                    : firstRateplan.name || firstRateplan.code,
                value: firstRateplan.id,
                data: firstRateplan,
              };
            }
          }
        },
        rejected: (state, action) => {
          state.error = action.error;
        },
        settled: (state, _) => {
          state.loading = false;
        },
      }
    ),
  }),
  selectors: {
    selectRateplans: (state) => state.rateplans,
    selectSelectedRateplan: (state) => state.selectedRateplan,
    selectLoading: (state) => state.loading,
    selectSelectedRateplanCurrency: (state) =>
      state.selectedRateplan?.data.currencyCode,
    selectEditableFilter: (state) => state.editableFilter,
    selectHasNegotiatedRateplans: (state) =>
      state.rateplans.some((rp) => rp.additionalData?.isNegotiated === true),
    selectNegotiatedRateplans: (state) =>
      state.rateplans.filter((rp) => rp.additionalData?.isNegotiated === true),
  },
});

export const {
  getRatePlansByPropertyId,
  setSelectedRateplan,
  setEditableFilter,
} = rateplanSlice.actions;

export const {
  selectRateplans,
  selectSelectedRateplan,
  selectLoading,
  selectSelectedRateplanCurrency,
  selectEditableFilter,
  selectHasNegotiatedRateplans,
  selectNegotiatedRateplans,
} = rateplanSlice.selectors;

export const isNegotiatedRateplan = (rateplan) =>
  rateplan?.data?.additionalData?.isNegotiated === true;

export default rateplanSlice;
